export const HRIS_PATH = '/hris'
// used in paginated requests
export const DEFAULT_CENSUS_FILES_PAGINATION_LIMIT = 5
